// Catalyst's <Link> wrapper, customized to use react-router-dom's <Link>
// so navigation stays client-side.

import * as Headless from '@headlessui/react';
import React, { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const Link = forwardRef(function Link(
  props: { href: string } & Omit<React.ComponentPropsWithoutRef<'a'>, 'href'>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  const { href, ...rest } = props;
  // External links + protocol-relative + hash anchors → plain <a>.
  const isExternal = /^([a-z]+:|\/\/)/i.test(href) || href.startsWith('#');
  if (isExternal) {
    return (
      <Headless.DataInteractive>
        <a href={href} {...rest} ref={ref} />
      </Headless.DataInteractive>
    );
  }
  return (
    <Headless.DataInteractive>
      <RouterLink to={href} {...rest} ref={ref as React.ForwardedRef<HTMLAnchorElement>} />
    </Headless.DataInteractive>
  );
});
